import { createNamespace } from "Common/namespaceUtils/namespaceRedux";
export const defaultTimeout = 500;
export const NAMESPACE = "requests";
export const FULL_NAMESPACE = createNamespace(NAMESPACE);
